import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';

const DISPLAY_COUNT = 12;
const SIZES = ['normal', 'normal', 'normal', 'tall', 'wide'];

function shuffle(array) {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

export default function WorksGallery() {
  const [active, setActive] = useState(null);
  const [works, setWorks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    getDocs(collection(db, 'works'))
      .then((snap) => {
        if (!isMounted) return;
        const all = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        const picked = shuffle(all).slice(0, DISPLAY_COUNT);
        setWorks(picked.map((w, pos) => ({ ...w, size: SIZES[pos % SIZES.length] })));
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => { isMounted = false; };
  }, []);

  return (
    <section id="works" className="pf-section pf-works">
      <div className="pf-section__head">
        <p className="pf-section__eyebrow">WORKS</p>
        <h2 className="pf-section__title">作品紹介</h2>
        <p className="pf-section__lead">墨と紙が織り成す、一瞬の呼吸を切り取った作品たち。</p>
      </div>

      {!loading && works.length === 0 && (
        <p className="pf-section__lead">作品を準備中です。</p>
      )}

      <div className="pf-works__grid">
        {works.map((w) => (
          <button
            key={w.id}
            className={`pf-works__item pf-works__item--${w.size}`}
            onClick={() => setActive(w)}
          >
            <img className="pf-works__img" src={w.url} alt="書道作品" loading="lazy" />
          </button>
        ))}
      </div>

      {active && (
        <div className="pf-lightbox" onClick={() => setActive(null)}>
          <div className="pf-lightbox__panel" onClick={(e) => e.stopPropagation()}>
            <img className="pf-lightbox__img" src={active.url} alt="書道作品" />
            <button className="pf-lightbox__close" onClick={() => setActive(null)}>閉じる ×</button>
          </div>
        </div>
      )}
    </section>
  );
}
